import type { CustomerType } from "@origin-digital/sales-cart";
import { dapiFetch } from "@origin-digital/daxi";
import {
  IEnergyPlan,
  IEnergyPlanApiResponse,
} from "@origin-digital/sales-common";
import { config } from "src/config";
import { getCustomerType } from "./pageContext";

export type CampaignPlans = {
  electricity?: IEnergyPlan;
  gas?: IEnergyPlan;
};

export const getCampaignPlans = async (
  originAddressId: string,
  solar: boolean = false,
  customerType: CustomerType = getCustomerType()
): Promise<CampaignPlans> => {
  try {
    const result = await dapiFetch<IEnergyPlanApiResponse>(
      `${config.apiBasePath}/v1/plans/campaign/movers-widget`,
      {
        params: {
          customerType,
          originAddressId,
          solar: `${solar}`,
        },
      }
    );

    const { electricity, gas } = result.data?.planAvailability || {};
    return {
      electricity: electricity?.[0]?.fuel?.[0],
      gas: gas?.[0]?.fuel?.[0],
    };
  } catch (e) {
    return {};
  }
};
